var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C8.9 1 6 3.6 6 6.7s2.6 6.9 6 12.3c3.4-5.4 6-9.1 6-12.3C18 3.6 15.1 1 12 1zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8 6h-3.1c-.4.6-.8 1.3-1.2 2h3.1l.5 1H15l-.3.5-.3.5h.6l.9 2H8.3l.9-2h.5l-.3-.5L9 18H7l-1-1h2.4c-.4-.7-.8-1.4-1.2-2H4l-4 8h24l-4-8zM7.2 21h-4L5 17.5 6.5 19H8l-.8 2zm8.8-2h3.8l1 2h-3.9l-.9-2z"
  })));
}

export default SvgIconAddress;